/**
 * AIDEN Streetwear -- Custom Animations
 */

const initCustomAnimations = () => {
  initCardReveal();
  initHeroParallax();
  initCatalogueVideoHeadings();
};

/**
 * Turn each catalogue drop heading (MOTION, ODYSSEY, ...) into a banner with a
 * looping background video while keeping the name as large text in front.
 * Implemented from JS so we don't touch the section's .liquid markup.
 */
function initCatalogueVideoHeadings() {
  const VIDEOS = {
    MOTION: 'https://cdn.shopify.com/videos/c/o/v/5eab1e2f9d1b412ebfeb4152c051810d.mp4',
    ODYSSEY: 'https://cdn.shopify.com/videos/c/o/v/c35d73bbf068444e891e17007cac00c7.mp4',
    OPULENCE: 'https://cdn.shopify.com/videos/c/o/v/eb12ff9b033e49cc9f52d28ccfc55e66.mp4'
  };

  const headings = document.querySelectorAll('.redhood-catalogue__heading');
  if (!headings.length) return;

  headings.forEach((heading) => {
    // Skip if already wrapped (re-init in the theme editor).
    if (heading.closest('.redhood-catalogue__hero')) return;

    const key = (heading.textContent || '').trim().toUpperCase();
    const src = VIDEOS[key];
    if (!src) return;

    const hero = document.createElement('div');
    hero.className = 'redhood-catalogue__hero';

    const video = document.createElement('video');
    video.className = 'redhood-catalogue__hero-video';
    video.src = src;
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'auto');
    video.setAttribute('aria-hidden', 'true');

    heading.parentNode.insertBefore(hero, heading);
    hero.appendChild(video);
    hero.appendChild(heading);

    const play = video.play();
    if (play && typeof play.catch === 'function') play.catch(() => {});
  });
}

function initCardReveal() {
  const cards = document.querySelectorAll('.card-wrapper');
  if (!cards.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const siblings = Array.from(entry.target.parentElement?.children || []);
        const idx = siblings.indexOf(entry.target);
        const delay = idx * 80;

        setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, delay);

        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.05,
    rootMargin: '0px 0px -40px 0px'
  });

  cards.forEach(card => observer.observe(card));
}

function initHeroParallax() {
  const bgWrapper = document.querySelector('[data-parallax]');
  if (!bgWrapper) return;

  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const rate = scrollY * 0.3;
        bgWrapper.style.setProperty('--parallax-y', `${rate}px`);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomAnimations);
} else {
  initCustomAnimations();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    initCustomAnimations();
  });
}
